import $ from "jquery";

const HeroStepForm = () => {
  const init = () => {
    onNominalChange();
    paymentType();
    handleStep();
    handleSubscriptionChange();
  };

  const handleStep = () => {
    const el = {
      button: ".HeroStepForm__Button",
      marker: ".js-HeroStepForm__Marker",
      step: ".js-HeroStepForm",
    };

    if ($(el.button).length === 0) return;

    $(document).on("click", el.button, function () {
      const target = $(this).data("target");
      $(el.step).hide("slow");
      $(`#${target}`).show("slow");
      $(el.marker).removeClass("active");
      $(`#Marker-${target}`).addClass("active");
    });
  };

  const onNominalChange = () => {
    const el = {
      inputFrom: ".js-HeroStepFormRadio__Nominal",
      customInput: ".js-HeroStepFormRadio__CustomNominal",
      caption: ".js-DescriptionBox__Caption",
      input: ".js-DescriptionBox__Input",
      descBox: ".js-DescriptionBox",
      note: ".js-DescriptionBox__Note",
    };

    if ($(el.inputFrom).length === 0) return;

    const firstCaption = $(el.inputFrom)[0].getAttribute("data-caption");
    $(el.caption).text(firstCaption).slideDown();

    $(document).on("change", el.inputFrom, function () {
      const caption = $(this).data("caption");
      if (caption) {
        $(el.descBox).removeClass("Input");
        $(el.caption).text(caption).slideDown();
        $(el.input).val("").slideUp();
        $(el.note).slideUp();
      } else {
        $(el.descBox).addClass("Input");
        $(el.caption).slideUp();
        $(el.input).val("").slideDown();
        $(el.note).slideDown();
      }
    });
  };

  const paymentType = () => {
    const el = {
      input: ".js-HeroStepForm__PaymentType",
      field: ".js-HeroStepForm__Field",
    };

    if ($(el.input).length === 0) return;

    $(document).on("change", el.input, function () {
      const val = $(this).val();

      $(el.field).slideUp();
      $(`#${val}`).slideDown();
    });
  };

  const handleSubscriptionChange = () => {
    const el = {
      input: ".js-HeroStepForm__Field--Radio__Donate",
      for: ".js-HeroStepForm__Field--ButtonGroup",
    };

    if ($(el.input).length === 0) return;

    $(document).on("change", el.input, function () {
      $(el.for).slideUp();
      const idFor = `#${$(this).data("id-for")}`;
      $(idFor).slideDown();
    });
  };

  init();
};

export default HeroStepForm;
